<script setup lang="ts">
import CreationFilter from '@/components/Menus/Filters/CreationFilter.vue';
import { type MessageSchema } from '@/i18n';
import { useDishesStore } from '@/stores/dishesStore';
// import { useUserStore } from '@/stores/useUserStore';
// import InputNumber from 'primevue/inputnumber';
import Slider from 'primevue/slider';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
// const user = ref(useUserStore().user);
const dishesStore = ref(useDishesStore());

const priceDisplay = computed(() => {
  const value = dishesStore.value.generationParams.max_price;
  if (value >= 1 && value <= 4) {
    return '$';
  } else if (value >= 5 && value <= 8) {
    return '$$';
  } else if (value >= 9 && value <= 12) {
    return '$$$';
  } else {
    return '$';
  }
});
</script>

<template>
  <CreationFilter>
    <template #title>{{ t('creationFilters.updateMaxPrice') }}</template>
    <template #content>
      <div class="w-10rem flex flex-row items-center justify-between">
        <!-- <InputNumber
          v-model.number="dishesStore.generationParams.max_price"
          class="w-full"
          disabled
          :suffix="` ${user?.restaurants[0].currency_symbol}`"
          locale="fr-CH"
        /> -->
        <div class="min-w-12 text-center font-semibold text-xl">
          {{ priceDisplay }}
        </div>
        <Slider v-model="dishesStore.generationParams.max_price" :step="1" :min="1" :max="12" class="w-full" />
      </div>
    </template>
  </CreationFilter>
</template>
